// extracted by mini-css-extract-plugin
module.exports = {"speakerModal":"SpeakerModal_speakerModal__3wzVT","arrowLeft":"SpeakerModal_arrowLeft__PoL-I","arrowRight":"SpeakerModal_arrowRight__24SV2","btns":"SpeakerModal_btns__1eI5W"};